
  import { Component, Prop, Vue} from "vue-property-decorator";
  import S3Image from "@/components/common/s3-image.vue";

  @Component({
    components: {
      S3Image,
    }
  })
  export default class CardItemCircle extends Vue {
    @Prop({type: [String, Number], default: undefined}) readonly text?: string | number;
    @Prop({type: String, default: undefined}) readonly avatar?: string;
  }
